import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Logo from "../triquetra-full-logo.svg";

const AboutModal = ({ toggleModal }) => {
  return (
    <div className="about-modal">
      <div className="modal">
        <div className="modal-header">
          <div className="modal-header-line-1">
            <h5 id="aboutTitle" className="modal-title">
              <img
                src={Logo}
                alt="Company Logo"
                className="logo"
                id="logoImage"
              />
            </h5>
            <button className="layer-layer-show" onClick={toggleModal}>
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
          <h4 className="modal-subtitle">
            Toolbox for assessing and mitigating Climate Change risks and
            natural hazards threatening cultural heritage
          </h4>
        </div>
        <div id="aboutContents" className="modal-body">
          <h3 style={{ color: "#578a27" }}>About the project</h3>
          <p>
            The TRIQUETRA project aims at creating an evidence-based assessment
            platform that allows precise risk stratification, and also creates a
            database of available mitigation measures and strategies, acting as
            a Decision Support Tool towards efficient risk mitigation and site
            remediation. The overall approach of Triquetra is based on three
            distinct steps:
          </p>{" "}
          <p>
            <b>1.</b> Risk Identification
            <br />
            <b>2.</b> Risk Quantification
            <br />
            <b>3.</b> Risk Mitigation
          </p>
          <p>
            This “trifecta” approach (hence the name Triquetra) creates a
            framework of risk assessment and risk mitigation so as to tackle as
            many of these risks as possible, in the most efficient way
            available. A total of 21 organizations from 7 countries participate
            in the project, including 8 Universities and Research Organizations
            and 6 Cultural Heritage Authorities. The project started on
            01/01/2023 and will last for 3 years. TRIQUETRA project is funded
            from the EU HE research and innovation programme under GA No.
            101094818.
          </p>
          <h3 style={{ color: "#578a27" }}>
            Addresed Cultural Heritage Typologies
          </h3>
          <p>
            <b>Mainland – rural areas</b> are less likely to be shielded in
            remote areas with scarce population and lack of surrounding
            infrastructure.
          </p>
          <p>
            <b>Underwater sites</b> are increasingly affected by climate change
            (e.g. changes in the chemical composition of oceans).
          </p>
          <p>
            <b>Coastal areas</b> shall be a focus for the approach to validate
            its various water-protection and water-related damage detecting
            techniques.
          </p>
          <p>
            {" "}
            Learn More{" "}
            <a
              href="https://triquetra-project.eu/"
              target="_blank"
              style={{ textDecoration: "underline" }}
            >
              here
            </a>
            .
          </p>
        </div>
        <div className="modal-footer">
          <div className="rights">
            <p>
              <b>
                Copyright © 2024 Geosystems Hellas SA - Triquetra project . All
                rights reserved.
              </b>
            </p>
          </div>
         

          {/* <div className="funding">
            <p>
              <b>
                Project funded from the EU HE research and innovation programme
                under GA No. 101094818
              </b>
            </p>
            <div className="eu-icon">
              <img
                src="https://triquetra-project.eu/wp-content/uploads/2023/02/EU-funding-logo-300x92.png"
                style={{ width: "100px" }}
              ></img>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
